export { default } from "./imageWidget";
